import React, { useState } from 'react';

import CardLayout from '@magoosh/layouts/card';

import ScoreReportPart from '../../components/score_report_part';
import SectionHeader from '../../components/section_header';
import { Answer, SpeakingScoreReport } from '../../../types';

interface Props {
  answers: Answer[];
  scoreReport: SpeakingScoreReport;
}

export default (props: Props) => {
  const [volume, setVolume] = useState(1);

  return (
    <CardLayout.Card className="d-flex flex-column flex-md-row gap-m gap-lg-xl">
      <SectionHeader
        subtitle={<>
          <div className="small">
            See which responses contributed to or detracted from your overall score.
          </div>

          {
            props.answers[0].question.referenceContent && (
              <div className="hidden-sm hidden-xs">
                <div className="d-flex flex-column gap-s u-margin-T-s">
                  <div><strong>Question reference</strong></div>
                  <div dangerouslySetInnerHTML={{
                    __html: props.answers[0].question.referenceContent
                  }} />
                </div>
              </div>
            )
          }
        </>}
        supertitle="Speaking analysis"
        supertitleIcon="file-text"
        title="How each response performed"
      />


      <div
        className="d-flex flex-1 flex-column gap-m"
        style={{ maxWidth: '100%', overflow: 'hidden' }}
      >
        {
          props.answers.map((answer) => {
            const scoreReportPart = (props.scoreReport?.content?.parts || []).find(
              (part) => part.answerId === answer.id
            );

            return (
              <div
                key={answer.id}
                className="u-border-A-s u-padding-A-s"
                style={{ borderRadius: 8 }}
              >
                <ScoreReportPart
                  answer={answer}
                  scoreReportPart={scoreReportPart}
                  volume={volume}
                  setVolume={setVolume}
                />
              </div>
            );
          })
        }
      </div>
    </CardLayout.Card>
  );
};
